import { View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { ICompany } from '../../../shared/interfaces';
import { getStringDateCity } from '../../../shared/utils/format-date';

interface DateCityProps {
  company: ICompany | null;
  issueDate?: string;
}

export const RDateCity: React.FC<DateCityProps> = ({ company, issueDate }) => {
  const { containerDateCity, dateCityText } = styles;
  if (!company) return <Text>Sem dados</Text>;

  return (
    <View style={containerDateCity}>
      <Text style={dateCityText}>{getStringDateCity(company, issueDate)}</Text>
    </View>
  );
};
